/**
 * Generates a media query string for responsive image sizes.
 *
 * @param minDesktopWidth - The minimum width for desktop media queries.
 * @param desktopImageSize - The image size to use on desktop.
 * @param fallbackImageSize - The image size to use on mobile (or smaller screens).
 *
 * @returns A media query string for use in the `sizes` attribute.
 */
const generateMediaQuery = (minDesktopWidth: number, desktopImageSize: string, fallbackImageSize: string): string =>
  `(min-width: ${minDesktopWidth}px) ${desktopImageSize}, ${fallbackImageSize}`;

export default generateMediaQuery;
